module.exports = __webpack_public_path__ + "01582d0281f826759100e9e91b29d559.otf";